import React from 'react'
import { Play } from 'lucide-react'
import { formatTimestamp, normalizeText } from '../utils/textUtils'

const EpisodeSection = ({ title, items, type, onPlayEpisode, colorClass = 'blue' }) => {
  const safeRender = (content) => {
    if (typeof content === 'string') return content
    if (typeof content === 'object' && content && content.content) return String(content.content)
    if (typeof content === 'object' && content && content.type && content.title) {
      return `${content.type} - ${content.title}`
    }
    return String(content || '')
  }

  const getIconColor = () => {
    switch (colorClass) {
      case 'blue': return 'bg-blue-400'
      case 'green': return 'bg-green-400'
      case 'yellow': return 'bg-yellow-400'
      case 'orange': return 'bg-orange-400'
      case 'purple': return 'bg-purple-400'
      default: return 'bg-blue-400'
    }
  }

  if (!items || items.length === 0) return null

  return (
    <div className="mb-4">
      <h4 className="text-base font-medium text-text-primary mb-2">
        {title}
      </h4>
      <div className="flex flex-col gap-1">
        {items.map((item, index) => (
          <div key={index} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm mb-1">
            <div className="flex-1">
              <p className="text-text-secondary leading-relaxed mb-0">
                {normalizeText(safeRender(item?.content || item))}
              </p>
            </div>
            <div className="w-full sm:w-32 shrink-0">
              {item?.timestamp && (
                <button
                  onClick={() => onPlayEpisode(item.timestamp)}
                  className="timestamp-btn text-xs font-medium w-full flex items-center justify-center"
                >
                  <Play size={14} className="shrink-0 mr-1" />
                  <span className="text-center">{formatTimestamp(item.timestamp)}</span>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default React.memo(EpisodeSection, (prevProps, nextProps) => {
  // Ne re-render que si les props importantes changent
  return prevProps.title === nextProps.title &&
         prevProps.items?.length === nextProps.items?.length &&
         prevProps.type === nextProps.type &&
         prevProps.colorClass === nextProps.colorClass
})